module.exports = __webpack_public_path__ + "static/media/kawasaki-green-bike.acbb2591.png";